/* VN filter pills: desktop dropdown pills + mobile size chips.
   Proxies the theme's own filter form (form.filter-form) so filtering logic stays native. */
(function () {
  var SKIP = /^(sort|ordenar|price|preço|preco)/i;
  var openKey = null;
  var busy = false;
  var lastSig = '';

  function css() {
    if (document.getElementById('vn-fp-css')) return;
    var s = document.createElement('style');
    s.id = 'vn-fp-css';
    s.textContent = [
      '.vn-fp{display:flex;flex-wrap:wrap;gap:8px;align-items:center;margin:0 0 -12px}',
      '.vn-fp__pill{position:relative}',
      '.vn-fp__btn{display:inline-flex;align-items:center;gap:6px;height:34px;padding:0 14px;border:1px solid #d9d9d9;border-radius:999px;background:#fff;color:#111;font:inherit;font-size:13px;cursor:pointer;white-space:nowrap}',
      '.vn-fp__btn:hover{border-color:#111}',
      '.vn-fp__btn.is-active{background:#6B01FF;border-color:#6B01FF;color:#fff}',
      '.vn-fp__btn svg{width:10px;height:10px;transition:transform .15s}',
      '.vn-fp__pill.is-open .vn-fp__btn svg{transform:rotate(180deg)}',
      '.vn-fp__panel{display:none;position:absolute;top:calc(100% + 6px);left:0;z-index:30;min-width:280px;max-width:340px;max-height:360px;overflow:auto;background:#fff;border:1px solid #e5e5e5;border-radius:12px;box-shadow:0 8px 24px rgba(0,0,0,.12);padding:10px 12px}',
      '.vn-fp__pill.is-open .vn-fp__panel{display:block}',
      '.vn-fp__panel ul{list-style:none;margin:0;padding:0;display:flex;flex-direction:column;gap:6px}',
      '.vn-fp__panel .filter-form__item{margin:0}',
      '.vn-fp__panel .js-expandable-content-btn,.vn-fp__panel .filter-form__search{display:none!important}',
      '.vn-fp__panel .d-none-important{display:flex!important}',
      '.vn-fp__panel ul,.vn-fp__panel [class*=expandable]{max-height:none!important;overflow:visible!important}',
      '.vn-fp__panel [data-vn-hidden]{display:none!important}',
      '.vn-fp__search{width:100%;height:34px;margin:0 0 8px;padding:0 10px;border:1px solid #d9d9d9;border-radius:8px;font:inherit;font-size:13px;box-sizing:border-box}',
      '.vn-fp__clear{display:block;margin-top:8px;background:none;border:0;padding:0;font:inherit;font-size:12px;text-decoration:underline;cursor:pointer;color:#555}',
      '.vn-sc{display:none}',
      '.product-grid-utilites{flex-wrap:wrap}',
      '.vn-fp,.vn-sc{flex:none;width:100%;box-sizing:border-box}',
      '.vn-sc{order:5}',
      '.product-grid-utilites.gradient-overlay::before,.js-collections-compare-btn.gradient-overlay::before{display:none!important;background:none!important}',
      '.vn-sc.is-2row{flex-wrap:wrap;overflow-x:visible;row-gap:8px}',
      '.vn-sc__br{flex-basis:100%;height:0;margin:0;padding:0}',
      '@media (max-width:1024px){.vn-fp{display:none!important}.vn-sc{display:flex;gap:8px;overflow-x:auto;padding:10px 0 2px;margin:0;scrollbar-width:none}.vn-sc::-webkit-scrollbar{display:none}',
      '.vn-sc__chip{flex:0 0 auto;height:32px;min-width:44px;padding:0 12px;border:1px solid #d9d9d9;border-radius:999px;background:#fff;color:#111;font:inherit;font-size:13px}',
      '.vn-sc__chip.is-active{background:#6B01FF;border-color:#6B01FF;color:#fff}}'
    ].join('\n');
    document.head.appendChild(s);
  }

  function groups(form) {
    var out = [];
    form.querySelectorAll('details').forEach(function (d) {
      var sum = d.querySelector('summary');
      if (!sum) return;
      var label = (sum.textContent || '').replace(/\s+/g, ' ').trim().replace(/\s*\(\d+\)$/, '');
      if (!label || SKIP.test(label)) return;
      var inputs = d.querySelectorAll('input[type=checkbox],input[type=radio]');
      if (!inputs.length) return;
      var checked = 0;
      inputs.forEach(function (i) { if (i.checked) checked++; });
      out.push({ d: d, label: label, inputs: inputs, checked: checked });
    });
    return out;
  }

  function findOriginal(form, name, value) {
    var list = form.querySelectorAll('input[name="' + name.replace(/"/g, '\\"') + '"]');
    for (var i = 0; i < list.length; i++) if (list[i].value === value) return list[i];
    return null;
  }

  function chevron() {
    return '<svg viewBox="0 0 10 6" aria-hidden="true"><path d="M1 1l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
  }

  function buildPanel(form, g) {
    var panel = document.createElement('div');
    panel.className = 'vn-fp__panel';
    var list = g.d.querySelector('ul');
    if (!list) { list = g.inputs[0].parentElement; while (list && list !== g.d && list.querySelectorAll('input[type=checkbox],input[type=radio]').length < g.inputs.length) list = list.parentElement; }
    var clone = list.cloneNode(true);
    clone.querySelectorAll('[id]').forEach(function (e) { e.id = 'vnfp-' + e.id; });
    clone.querySelectorAll('label[for]').forEach(function (e) { e.setAttribute('for', 'vnfp-' + e.getAttribute('for')); });
    clone.querySelectorAll('[hidden],.d-none,.is-hidden,.d-none-important').forEach(function (e) { e.hidden = false; e.classList.remove('d-none', 'is-hidden', 'd-none-important'); });
    clone.querySelectorAll('input[type=checkbox],input[type=radio]').forEach(function (i) {
      var name = i.getAttribute('name');
      i.setAttribute('data-vn-name', name);
      i.removeAttribute('name');
      i.removeAttribute('form');
      i.addEventListener('change', function (e) {
        e.stopPropagation();
        var o = findOriginal(form, name, i.value);
        if (o) { var vp = i.closest('.vn-fp__panel'); var vs = vp && vp.querySelector('.vn-fp__search'); window.__vnfpScroll = vp ? vp.scrollTop : 0; window.__vnfpQ = vs ? vs.value : ''; o.click(); openKey = g.label; if (vp && vp.parentElement) vp.parentElement.classList.add('is-open'); } // VN: the forwarded click bubbles to the document 'click outside' handler, which closed the dropdown; keep it open
      });
    });
    if (g.inputs.length > 20) {
      var s = document.createElement('input');
      s.type = 'search';
      s.className = 'vn-fp__search';
      s.placeholder = document.documentElement.lang && /^pt/i.test(document.documentElement.lang) ? 'Pesquisar…' : 'Search…';
      s.addEventListener('input', function () {
        var q = s.value.toLowerCase().trim();
        clone.querySelectorAll('input[data-vn-name]').forEach(function (i) {
          var item = i.closest('li') || i.parentElement;
          var t = (item.textContent || '').toLowerCase();
          if (q && t.indexOf(q) < 0) item.setAttribute('data-vn-hidden', ''); else item.removeAttribute('data-vn-hidden');
        });
      });
      panel.appendChild(s);
    }
    panel.appendChild(clone);
    if (g.checked) {
      var c = document.createElement('button');
      c.type = 'button';
      c.className = 'vn-fp__clear';
      c.textContent = /^pt/i.test(document.documentElement.lang || '') ? 'Limpar' : 'Clear';
      c.addEventListener('click', function () {
        openKey = null;
        var u = new URL(location.href);
        u.searchParams.delete(g.inputs[0].getAttribute('name'));
        u.searchParams.delete('page');
        location.assign(u.toString());
      });
      panel.appendChild(c);
    }
    return panel;
  }

  function closeAll(except) {
    document.querySelectorAll('.vn-fp__pill.is-open').forEach(function (p) { if (p !== except) p.classList.remove('is-open'); });
  }

  function buildPills(form, gs) {
    var hdr = document.querySelector('.product-grid--header');
    if (!hdr) return;
    var old = hdr.parentElement.querySelector('.vn-fp');
    if (old) old.remove();
    var wrap = document.createElement('div');
    wrap.className = 'vn-fp';
    gs.forEach(function (g) {
      var pill = document.createElement('div');
      pill.className = 'vn-fp__pill';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'vn-fp__btn' + (g.checked ? ' is-active' : '');
      btn.innerHTML = '<span></span>' + chevron();
      btn.firstChild.textContent = g.label + (g.checked ? ' · ' + g.checked : '');
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = !pill.classList.contains('is-open');
        closeAll(pill);
        pill.classList.toggle('is-open', open);
        openKey = open ? g.label : null;
        if (open) { var s = pill.querySelector('.vn-fp__search'); if (s) s.focus(); }
      });
      pill.appendChild(btn);
      var panel = buildPanel(form, g);
      panel.addEventListener('click', function (e) { e.stopPropagation(); });
      pill.appendChild(panel);
      if (openKey === g.label) { pill.classList.add('is-open'); requestAnimationFrame(function () { var q = pill.querySelector('.vn-fp__search'); if (q && window.__vnfpQ) { q.value = window.__vnfpQ; q.dispatchEvent(new Event('input')); } window.__vnfpQ = ''; panel.scrollTop = window.__vnfpScroll || 0; }); } // VN: reopen + restore scroll/search
      wrap.appendChild(pill);
    });
    hdr.parentElement.insertBefore(wrap, hdr);
  }

  function buildChips(form, gs) {
    var size = gs.filter(function (g) { return /^(size|tamanho)/i.test(g.label); })[0];
    var hdr = document.querySelector('.product-grid--header');
    if (!hdr) return;
    var old = hdr.parentElement.querySelector('.vn-sc');
    if (old) old.remove();
    if (!size) return;
    var row = document.createElement('div');
    row.className = 'vn-sc';
    [].forEach.call(size.inputs, function (i) {
      var item = i.closest('li') || i.parentElement;
      var cnt = item.querySelector('sup');
      var n = cnt ? parseInt(cnt.textContent.replace(/\D/g, ''), 10) : 1;
      if (!i.checked && n === 0) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'vn-sc__chip' + (i.checked ? ' is-active' : '');
      b.textContent = i.value;
      b.addEventListener('click', function () { i.click(); });
      row.appendChild(b);
    });
    if (row.children.length) { hdr.parentElement.insertBefore(row, hdr); layoutChips(); }
  }

  function layoutChips() {
    var row = document.querySelector('.vn-sc');
    if (!row || !row.offsetParent) return;
    row.classList.remove('is-2row');
    var br = row.querySelector('.vn-sc__br');
    if (br) br.remove();
    if (row.scrollWidth <= row.clientWidth + 2) return;
    var chips = row.querySelectorAll('.vn-sc__chip');
    var half = Math.ceil(chips.length / 2);
    var b = document.createElement('span');
    b.className = 'vn-sc__br';
    row.insertBefore(b, chips[half] || null);
    row.classList.add('is-2row');
  }

  function init() {
    if (busy) return;
    var form = document.querySelector('form.filter-form');
    if (!form || !document.querySelector('.product-grid--header')) return;
    busy = true;
    try {
      css();
      var gs = groups(form);
      var sig = gs.map(function (g) {
        return g.label + ':' + [].map.call(g.inputs, function (i) { var it = i.closest('li') || i.parentElement; var c = it.querySelector('sup'); return (i.checked ? '1' : '0') + (c ? c.textContent.trim() : ''); }).join(',');
      }).join('|');
      if (sig === lastSig && document.querySelector('.vn-fp')) { busy = false; return; }
      lastSig = sig;
      buildPills(form, gs);
      buildChips(form, gs);
    } catch (e) { if (window.console) console.warn('vn-filter-pills', e); }
    busy = false;
  }

  var t;
  function schedule() { clearTimeout(t); t = setTimeout(init, 120); }

  document.addEventListener('click', function () { closeAll(null); openKey = null; });
  var rt;
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(layoutChips, 150); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeAll(null); openKey = null; } });

  function start() {
    init();
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var n = muts[i].target;
        if (n.closest && n.closest('.vn-fp,.vn-sc')) continue;
        if (!document.querySelector('.vn-fp')) { schedule(); return; }
        if (n.closest && n.closest('form.filter-form,.product-grid--header')) { schedule(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
